import React, { useEffect, useState } from 'react';
import { Button, Container, Table } from 'react-bootstrap';
import ReservaFormModal from './ReservaFormModal';
import AsignarMesasModal from './AsignarMesasModal';
import api from '../../api/axios';

const ReservasView = () => {
  const [reservas, setReservas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);
const [showAsignarModal, setShowAsignarModal] = useState(false);


  const business = JSON.parse(localStorage.getItem('business'));

  const fetchReservas = async () => {
    try {
const res = await api.get(`/reservas`);
      setReservas(res.data);
    } catch (err) {
      console.error('Error al obtener reservas:', err);
    }
  };

const handleAsignarMesa = (reserva) => {
  setReservaSeleccionada(reserva);
  setShowAsignarModal(true);
};

const handleVerReserva = (reserva) => {
  // Futuro modal de acciones (Ver / Cancelar)
  console.log('Ver reserva:', reserva);
  // setShowVerReservaModal(true);  // Podés activar esto cuando lo tengas hecho
};



  useEffect(() => {
    fetchReservas();
  }, []);




  return (
    <Container className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>📅 Reservas</h3>
        <Button onClick={() => setShowModal(true)}>➕ Crear Reserva</Button>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Fecha</th>
            <th>Hora</th>
            <th>Personas</th>
            <th>Estado</th>
             <th>Mesa asignada</th>
                <th>Acciones</th> {/* 👈 Agregar esta línea */}

          </tr>
        </thead>
        <tbody>
          {reservas.map((reserva) => (
            <tr key={reserva.id}>
              <td>{reserva.nombre_cliente}</td>
              <td>{reserva.fecha}</td>
              <td>{reserva.hora}</td>
              <td>{reserva.personas}</td>
              <td>{reserva.estado}</td>
       <td>{reserva.mesas_asignadas || '-'}</td>

            <td>
  {reserva.estado === 'pendiente' ? (
    <Button variant="primary" onClick={() => handleAsignarMesa(reserva)}>
      🪑 Asignar Mesa
    </Button>
  ) : (
    <Button variant="secondary" onClick={() => handleVerReserva(reserva)}>
      🔍 Ver / Cancelar
    </Button>
  )}
</td>



            </tr>
          ))}
        </tbody>
      </Table>

      <ReservaFormModal show={showModal} onClose={() => setShowModal(false)} onSuccess={fetchReservas} />
    {reservaSeleccionada && (
  <AsignarMesasModal
    show={showAsignarModal}
    onClose={() => setShowAsignarModal(false)}
    reserva={reservaSeleccionada}
    onSuccess={() => {
      fetchReservas();
      setShowAsignarModal(false);
    }}
  />
)}
    </Container>
  
);


};

export default ReservasView;
